import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import BaseAutopilotSidebarStyles from 'screens/VirtualMarketerOnboarding/AutopilotSidebar/AutopilotSidebar.module.scss'
import Styles from './AutopilotSidebar.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { SupportChat } from 'components/FirstTimeExperienceModal/components/SupportChat/SupportChat'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'
import { Check02 } from 'blaze-ui/icons/16'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Your Brand Profile',
          text: 'Blaze learned about your business from everything you shared. This profile guides your content strategy.',
        },
        {
          heading: 'How to edit',
          text: 'Click any section to refine it. Hit "Looks Good" when you’re finished.',
        },
      ]}
    />
  )
}

interface Section {
  heading: string
  text: string
}

export const BaseAutopilotSidebar = ({
  showSupportButton = true,
  sections,
}: {
  showSupportButton?: boolean
  sections: Section[]
}) => {
  const isOnboardingRedesign = useIsOnboardingRedesign()

  if (isOnboardingRedesign) {
    return (
      <div className={Styles.brandProfileSideContentWrapper}>
        <div className={Styles.brandProfileSideContent}>
          <div className={Styles.item}>
            <Heading level={5}>Review your Brand Profile</Heading>
            <Text variant="secondary" color="var(--dark-80)">
              We pulled this information from your website. Edit anything that needs adjustment before continuing.
            </Text>
          </div>
          <div className={Styles.itemWithList}>
            <Heading level={5}>What to check:</Heading>
            <div className={Styles.listItem}>
              <div className={Styles.check}>
                <Check02 size={9} color="var(--light-100)" />
              </div>
              <Text variant="secondary" color="var(--dark-80)">
                Core identity is accurate
              </Text>
            </div>
            <div className={Styles.listItem}>
              <div className={Styles.check}>
                <Check02 size={9} color="var(--light-100)" />
              </div>
              <Text variant="secondary" color="var(--dark-80)">
                Market positioning makes sense
              </Text>
            </div>
            <div className={Styles.listItem}>
              <div className={Styles.check}>
                <Check02 size={9} color="var(--light-100)" />
              </div>
              <Text variant="secondary" color="var(--dark-80)">
                Competitive advantages are complete
              </Text>
            </div>
          </div>
          <div className={Styles.item}>
            <Heading level={5}>Need to add or edit?</Heading>
            <Text variant="secondary" color="var(--dark-80)">
              Click any section to edit directly.
            </Text>
          </div>
          <div className={Styles.item}>
            <Heading level={5}>Why this matters:</Heading>
            <Text variant="secondary" color="var(--dark-80)">
              With an accurate brand profile, Blaze will create relevant content.
            </Text>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={cx(BaseAutopilotSidebarStyles.container, Styles.container)}>
      <div className={BaseAutopilotSidebarStyles.content}>
        {sections.map((section) => (
          <div className={BaseAutopilotSidebarStyles.text} key={section.heading}>
            <Heading level={5}>{section.heading}</Heading>
            <Text variant="placeholder" color="var(--dark-80)">
              {section.text}
            </Text>
          </div>
        ))}
        {showSupportButton && <SupportChat />}
      </div>
    </div>
  )
}
